import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { InstallationDetailsStore } from '@store';
import { filter, map, switchMap } from 'rxjs/operators';
import { RoutingService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class PermanentInspectionGuard {
  constructor(
    private installationDetailsStore: InstallationDetailsStore,
    private routingService: RoutingService
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.installationDetailsStore.device$.pipe(
      filter((device) => device.gatewaySerial !== undefined),
      switchMap(() => this.installationDetailsStore.isPermanentInspectionMenuItemVisible()),
      map((isVisible) => {
        // cancel navigation
        if (!isVisible) {
          this.routingService.navigateToInstallationDashboardFromGuard(state);

          return false;
        }

        return true;
      })
    );
  }
}
